<mat-form-field appearance="outline">
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <input id="genericSearch-input-{{testingId | camelCase}}" #search matInput placeholder="{{ placeholder }}" type="text" [formControl]="searchForm" autocomplete="off" />
  <mat-progress-spinner *ngIf="loading; else clear" [mode]="'indeterminate'" [diameter]="23" matSuffix></mat-progress-spinner>
  <ng-template #clear>
    <button id="genericSearch-button-clear" mat-icon-button matSuffix (click)="clearSearch.emit()"><mat-icon>close</mat-icon></button>
  </ng-template>
</mat-form-field>
